export default __webpack_public_path__ + "assets/search.021e0837.svg";